import { render, staticRenderFns } from "./EditLesson.vue?vue&type=template&id=5155c72a&"
import script from "./EditLesson.vue?vue&type=script&lang=js&"
export * from "./EditLesson.vue?vue&type=script&lang=js&"
import style0 from "./EditLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports